import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { OverviewStats } from '../types';
import styles from '../../../../../../styles/OverviewTab.module.css';

interface TaskStatusChartProps {
  stats: OverviewStats;
}

const doughnutOptions = {
  responsive: true,
  maintainAspectRatio: false,
  cutout: '70%',
  plugins: {
    legend: {
      position: 'bottom' as const,
      labels: {
        usePointStyle: true,
        padding: 15,
        font: {
          size: 12,
          weight: 'normal' as const,
          family: 'var(--font-main)',
        },
        color: '#374151',
      },
    },
    tooltip: {
      backgroundColor: 'rgba(0, 0, 0, 0.85)',
      padding: 12,
      titleFont: {
        size: 13,
        weight: 'bold' as const,
        family: 'var(--font-main)',
      },
      bodyFont: {
        size: 12,
        weight: 'normal' as const,
        family: 'var(--font-main)',
      },
      titleColor: '#ffffff',
      bodyColor: '#ffffff',
      borderColor: '#e5e7eb',
      borderWidth: 1,
      cornerRadius: 8,
      displayColors: true,
      callbacks: {
        label: (context: any) => {
          const label = context.label || '';
          const value = context.parsed || 0;
          const total = context.dataset.data.reduce((a: number, b: number) => a + b, 0);
          const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : 0;
          return `${label}: ${value} (${percentage}%)`;
        },
      },
    },
  },
};

const TaskStatusChart: React.FC<TaskStatusChartProps> = ({ stats }) => {
  const pending_tasks = stats.total_tasks - stats.completed_tasks;
  
  const chartData = {
    labels: ['Completed', 'Pending'],
    datasets: [
      {
        data: [stats.completed_tasks, pending_tasks],
        backgroundColor: [
          '#10b981',
          '#6b7280',
        ],
        borderColor: [
          '#ffffff',
          '#ffffff',
        ],
        borderWidth: 3,
        hoverOffset: 8,
        hoverBorderWidth: 4,
      },
    ],
  };

  const centerText = stats.total_tasks > 0 
    ? `${stats.completed_tasks}`
    : '0';

  return (
    <div className={styles.overviewCard}>
      <h3 className={styles.cardTitle}>
        <svg className={styles.cardIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
          <polyline points="3.27,6.96 12,12.01 20.73,6.96"></polyline>
          <line x1="12" y1="22.08" x2="12" y2="12"></line>
        </svg>
        Task Status Distribution
      </h3>
      <div className={styles.chartContainer}>
        {stats.total_tasks > 0 ? (
          <div style={{ position: 'relative', height: '100%' }}>
            <Doughnut data={chartData} options={doughnutOptions} />
            
          </div>
        ) : (
          <div className={styles.chartPlaceholder}>
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"></circle>
              <path d="M12 6v6l4 2"></path>
            </svg>
            <span>No data available</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default TaskStatusChart;

